module.exports = "<div class=row> <div class=col-xs-12> <div class=form-group> <app-widgets-label i18n-label=\"Description Sector\" i18n-help=\"Description Sector Help\"></app-widgets-label> <app-i18n-textarea field=route.teaser main-lang=route.main_lang></app-i18n-textarea> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/edit/general/partial_climbing.html
// module id = 469
// module chunks = 0